import { createElement } from 'react';
import './message-list-item.scss';
import { convertChildren } from '../../utils/children-node-handle';
const MessageListItem = ({ onClick = () => { }, title, image, gmtCreate, children, description, isRead, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "message-list__panel__item", onClick: onClick, ..._otherProps },
        convertChildren(children, 'image', { src: image }),
        isRead ? null : createElement("span", { className: "badge" }),
        createElement("div", { className: "message-list__panel__item__text" },
            convertChildren(children, 'title', { children: [title] }),
            convertChildren(children, 'gmtCreate', { children: [gmtCreate] }),
            convertChildren(children, 'content', { children: [description] }))));
};
MessageListItem.displayName = 'TeletextListItem';
export default MessageListItem;
